export default __webpack_public_path__ + "static/media/surfboard.246964fd.svg";